var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4472 4.10557C12.1657 3.96481 11.8343 3.96481 11.5528 4.10557L2.55279 8.60557C2.21401 8.77496 2.00001 9.12123 2.00001 9.5C2.00001 9.87877 2.21401 10.225 2.55279 10.3944L11.5528 14.8944C11.8343 15.0352 12.1657 15.0352 12.4472 14.8944L21.4472 10.3944C21.786 10.225 22 9.87877 22 9.5C22 9.12123 21.786 8.77496 21.4472 8.60557L12.4472 4.10557ZM12 12.882L5.23607 9.5L12 6.11803L18.7639 9.5L12 12.882Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44722 13.6056C2.95324 13.3586 2.35257 13.5588 2.10558 14.0528C1.85859 14.5468 2.05881 15.1474 2.55279 15.3944L11.5528 19.8944C11.8343 20.0352 12.1657 20.0352 12.4472 19.8944L21.4472 15.3944C21.9412 15.1474 22.1414 14.5468 21.8944 14.0528C21.6474 13.5588 21.0468 13.3586 20.5528 13.6056L12 17.882L3.44722 13.6056Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.64d0b6959d20980090c6c240610a3886.svg";
export { ForwardRef as ReactComponent };